import type { ReactNode } from 'react';

export const symbol_done_outline: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m381-242 453-453-43-43-410 410-211-211-43 43 254 254Zm-42 43L84-454q-9-9-13-20t-4-22q0-11 4-22t13-20l44-44q9-9 20-13t22-4q11 0 22 4t20 13l169 169 368-368q9-9 20-13t22-4q11 0 22 4t20 13l44 44q9 9 13 20t4 22q0 11-4 22t-13 20L423-199q-9 9-20 13t-22 4q-11 0-22-4t-20-13Z"
		/>
	</svg>
);
